const user = JSON.parse(localStorage.getItem('userData'))
const menu = [
  {
    header: 'Usuarios',
    roles: [1], // Solo admin
  },
  {
    title: 'Usuarios',
    route: 'admin-users',
    icon: 'UsersIcon',
    roles: [1], // Solo admin
  },
  {
    header: 'Clínicas',
    roles: [1], // Solo admin
  },
  {
    title: 'Clínicas',
    route: 'admin-clinics',
    icon: 'ActivityIcon',
    roles: [1], // Solo admin
  },
  {
    title: 'Asignar Odontólogos',
    route: 'admin-clinic-dentists',
    icon: 'UserPlusIcon',
    roles: [1], // Solo admin
  },
  {
    header: 'Pedidos',
    roles: [1, 2, 3, 4, 5], // admin, comercial, planificador
  },
  {
    title: 'Pedidos',
    route: 'admin-orders',
    icon: 'ListIcon',
    roles: [1, 2, 5], // admin, comercial, odontologo
  },
  {
    title: 'Planificación',
    route: 'admin-planning-orders',
    icon: 'CalendarIcon',
    roles: [1, 3], // admin, planificador
  },
  {
    title: 'Fabricación',
    route: 'admin-manufacturing-orders',
    icon: 'ToolIcon',
    roles: [1, 2, 4], // admin, comercial, tecnico
  },
  {
    header: 'Agenda',
    roles: [1, 2, 3, 4, 5], // admin, comercial, planificador
  },
  {
    title: 'Ver Agendas',
    route: 'admin-schedule-list',
    icon: 'CalendarIcon',
    roles: [1, 2, 4], // admin, comercial, tecnico
  },
]

const filteredMenu = menu.filter(item => item.roles.includes(parseInt(user.role_id, 10)))

console.log(parseInt(user.role_id, 10), filteredMenu, user)
export default filteredMenu
